/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { styled } from '@material-ui/core';
import React from 'react';

import { Actionable, Col, Container, IconLogo } from 'components/UI';
import { Breakpoints } from 'utils/enums';

const ColLeft = styled(Col)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  marginTop: theme.spacing(5),
}));

const ColRight = styled(Col)(({ theme }) => ({
  '& > *': { marginLeft: '1em' },

  display: 'none',
  marginBottom: theme.spacing(5),
  marginTop: theme.spacing(5),

  [theme.breakpoints.up(Breakpoints.Md)]: {
    display: 'flex',
  },
}));

interface HeaderCompactProps {
  children?: React.ReactNode;
  linkInstance: React.ElementType;
}

const HeaderCompact: React.FC<HeaderCompactProps> = ({
  children,
  linkInstance,
}) => {
  return (
    <Container>
      <ColLeft
        container
        alignItems="center"
        justifyContent="space-between"
        xs={12}
        sm={3}
      >
        <Actionable component={linkInstance} to="/">
          <IconLogo />
        </Actionable>
      </ColLeft>

      <ColRight container justifyContent="flex-end" sm={9}>
        {children}
      </ColRight>
    </Container>
  );
};

export { HeaderCompact };
